module.exports = __webpack_public_path__ + "img/图片2.3d70ac71.png";